module.exports = __webpack_public_path__ + "static/img/forward.b1504c9f.svg";